// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Scalar from "../../core/Scalar.res.js";
import * as Client from "@apollo/client";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let Raw = {};

let query = Client.gql(["query OrderSuppliesQuery($cku: CKU!, $first: Int, $filterBy: InputOrderProductsByVariantCkuQueryFilter)  {\norderProductsByVariantCku(cku: $cku, first: $first, filterBy: $filterBy)  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nquantity  \ntotalAmountIncludingTaxes  \ntotalAmountExcludingTaxes  \norder  {\n__typename  \nshopName  \nid  \nname  \nreceptionFinishedAt  \nsupplierCompanyName  \nsupplier  {\n__typename  \nid  \n}\n\n}\n\n}\n\n}\n\npageInfo  {\n__typename  \nhasNextPage  \n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.orderProductsByVariantCku;
  let value$2 = value$1.edges;
  let value$3 = value$1.pageInfo;
  let value$4 = value$3.hasNextPage;
  return {
    orderProductsByVariantCku: {
      __typename: value$1.__typename,
      edges: value$2.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.order;
        let tmp;
        if (value$2 == null) {
          tmp = undefined;
        } else {
          let value$3 = value$2.name;
          let value$4 = value$2.receptionFinishedAt;
          let value$5 = value$2.supplier;
          tmp = {
            __typename: value$2.__typename,
            shopName: value$2.shopName,
            id: value$2.id,
            name: !(value$3 == null) ? value$3 : undefined,
            receptionFinishedAt: !(value$4 == null) ? Scalar.Datetime.parse(value$4) : undefined,
            supplierCompanyName: value$2.supplierCompanyName,
            supplier: !(value$5 == null) ? ({
                __typename: value$5.__typename,
                id: value$5.id
              }) : undefined
          };
        }
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            quantity: value$1.quantity,
            totalAmountIncludingTaxes: value$1.totalAmountIncludingTaxes,
            totalAmountExcludingTaxes: value$1.totalAmountExcludingTaxes,
            order: tmp
          }
        };
      }),
      pageInfo: {
        __typename: value$3.__typename,
        hasNextPage: !(value$4 == null) ? value$4 : undefined
      }
    }
  };
}

function serialize(value) {
  let value$1 = value.orderProductsByVariantCku;
  let value$2 = value$1.pageInfo;
  let value$3 = value$2.hasNextPage;
  let hasNextPage = value$3 !== undefined ? value$3 : null;
  let value$4 = value$2.__typename;
  let pageInfo = {
    __typename: value$4,
    hasNextPage: hasNextPage
  };
  let value$5 = value$1.edges;
  let edges = value$5.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.order;
    let order;
    if (value$2 !== undefined) {
      let value$3 = value$2.supplier;
      let supplier;
      if (value$3 !== undefined) {
        let value$4 = value$3.id;
        let value$5 = value$3.__typename;
        supplier = {
          __typename: value$5,
          id: value$4
        };
      } else {
        supplier = null;
      }
      let value$6 = value$2.supplierCompanyName;
      let value$7 = value$2.receptionFinishedAt;
      let receptionFinishedAt = value$7 !== undefined ? Scalar.Datetime.serialize(value$7) : null;
      let value$8 = value$2.name;
      let name = value$8 !== undefined ? value$8 : null;
      let value$9 = value$2.id;
      let value$10 = value$2.shopName;
      let value$11 = value$2.__typename;
      order = {
        __typename: value$11,
        shopName: value$10,
        id: value$9,
        name: name,
        receptionFinishedAt: receptionFinishedAt,
        supplierCompanyName: value$6,
        supplier: supplier
      };
    } else {
      order = null;
    }
    let value$12 = value$1.totalAmountExcludingTaxes;
    let value$13 = value$1.totalAmountIncludingTaxes;
    let value$14 = value$1.quantity;
    let value$15 = value$1.__typename;
    let node = {
      __typename: value$15,
      quantity: value$14,
      totalAmountIncludingTaxes: value$13,
      totalAmountExcludingTaxes: value$12,
      order: order
    };
    let value$16 = value.__typename;
    return {
      __typename: value$16,
      node: node
    };
  });
  let value$6 = value$1.__typename;
  let orderProductsByVariantCku = {
    __typename: value$6,
    edges: edges,
    pageInfo: pageInfo
  };
  return {
    orderProductsByVariantCku: orderProductsByVariantCku
  };
}

function serializeInputObjectDateFilter(inp) {
  let a = inp._after;
  let a$1 = inp._before;
  let a$2 = inp._between;
  return {
    _after: a !== undefined ? a : undefined,
    _before: a$1 !== undefined ? a$1 : undefined,
    _between: a$2 !== undefined ? a$2.map(b => b) : undefined
  };
}

function serializeInputObjectInFilter(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}

function serializeInputObjectInputOrderProductsByVariantCkuQueryFilter(inp) {
  let a = inp.archived;
  let a$1 = inp.receptionFinishedAt;
  let a$2 = inp.shopIds;
  return {
    archived: a !== undefined ? (
        a === "ONLY" ? "ONLY" : (
            a === "INCLUDED" ? "INCLUDED" : "EXCLUDED"
          )
      ) : undefined,
    receptionFinishedAt: a$1 !== undefined ? serializeInputObjectDateFilter(a$1) : undefined,
    shopIds: a$2 !== undefined ? serializeInputObjectInFilter(a$2) : undefined
  };
}

function serializeVariables(inp) {
  let a = inp.first;
  let a$1 = inp.filterBy;
  return {
    cku: inp.cku,
    first: a !== undefined ? a : undefined,
    filterBy: a$1 !== undefined ? serializeInputObjectInputOrderProductsByVariantCkuQueryFilter(a$1) : undefined
  };
}

function makeVariables(cku, first, filterBy, param) {
  return {
    cku: cku,
    first: first,
    filterBy: filterBy
  };
}

function makeInputObjectInputOrderProductsByVariantCkuQueryFilter(archived, receptionFinishedAt, shopIds, param) {
  return {
    archived: archived,
    receptionFinishedAt: receptionFinishedAt,
    shopIds: shopIds
  };
}

function makeInputObjectDateFilter(_after, _before, _between, param) {
  return {
    _after: _after,
    _before: _before,
    _between: _between
  };
}

function makeInputObjectInFilter(_in, param) {
  return {
    _in: _in
  };
}

let OrderSuppliesQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputOrderProductsByVariantCkuQueryFilter: serializeInputObjectInputOrderProductsByVariantCkuQueryFilter,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables,
  makeInputObjectInputOrderProductsByVariantCkuQueryFilter: makeInputObjectInputOrderProductsByVariantCkuQueryFilter,
  makeInputObjectDateFilter: makeInputObjectDateFilter,
  makeInputObjectInFilter: makeInputObjectInFilter
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let OrderSuppliesQuery_refetchQueryDescription = include.refetchQueryDescription;

let OrderSuppliesQuery_use = include.use;

let OrderSuppliesQuery_useLazy = include.useLazy;

let OrderSuppliesQuery_useLazyWithVariables = include.useLazyWithVariables;

let OrderSuppliesQuery = {
  OrderSuppliesQuery_inner: OrderSuppliesQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputOrderProductsByVariantCkuQueryFilter: serializeInputObjectInputOrderProductsByVariantCkuQueryFilter,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables,
  makeInputObjectInputOrderProductsByVariantCkuQueryFilter: makeInputObjectInputOrderProductsByVariantCkuQueryFilter,
  makeInputObjectDateFilter: makeInputObjectDateFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  refetchQueryDescription: OrderSuppliesQuery_refetchQueryDescription,
  use: OrderSuppliesQuery_use,
  useLazy: OrderSuppliesQuery_useLazy,
  useLazyWithVariables: OrderSuppliesQuery_useLazyWithVariables
};

let edgesPerFetch = 5;

export {
  edgesPerFetch,
  OrderSuppliesQuery,
}
/* query Not a pure module */
